import { websiteOriginForAdmin } from "@podecontratar/shared/lib/admin-origin";

/**
 * Resolve the website origin for the env this SPA is running in.
 *
 * `admin.podecontratar.com`         → `https://www.podecontratar.com`
 * `admin.pc.zarv.dev`                → `https://pc.zarv.dev` (staging)
 * `localhost:3002`                  → `http://localhost:3001` (`pnpm dev`)
 *
 * The host-derived form means one build works for prod and staging — we
 * don't have to bake the URL into the bundle at build time. Locally,
 * `VITE_WEBSITE_ORIGIN` points at a site started on a non-default `PORT=`.
 * SSR-safe fallback returns the prod origin so unit tests don't blow up.
 */
export function websiteOrigin(): string {
  if (typeof window === "undefined") return "https://www.podecontratar.com";
  return websiteOriginForAdmin(window.location.origin, import.meta.env.VITE_WEBSITE_ORIGIN);
}
